<template>
  <div class="pagination-items-show">
    <div class="pagination-items-show__label">
      {{ _getTr("show_per_page") }}
    </div>
    <MSelectControl
      class="pagination-items-show__input"
      :choices="choices"
      :value="perPage"
      :required="true"
      :search="false"
      :small="true"
      dropdown-position="auto"
      @input="$emit('changePerPage', $event)"
    />
  </div>
</template>

<script>
  import MSelectControl from 'components/Inputs/Select/MSelectControl/MSelectControl';

  export default {
    name: 'PaginationItemsShow',
    components: {MSelectControl},
    props: {
      perPage: {
        type: Number,
        required: true
      },
      perPageChoices: {
        type: Array,
        default: () => [10, 20, 50, 100]
      }
    },
    computed: {
      choices () {
        return this.perPageChoices.map(x => ({id: x, text: `${x}`}));
      }
    }
  };
</script>

<style>
  .pagination-items-show {
    text-align: center;

    display: flex;

    flex-wrap: nowrap;
    align-items: center;

    margin-right: 18px;
  }

  .pagination-items-show__label {
    margin-right: 8px;
  }

  @media (--extra-small), (--small) {
    .pagination-items-show {
      margin-right: 7px;
    }
  }

  @media (--extra-small) {
    .pagination-items-show {
      margin-top: 10px;
      margin-right: initial;
    }
  }
</style>
